import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './MainMenu.scss';
import { FansaLogo } from '../utils/icons';
import { connect } from 'react-redux'
import MenuBar from './MenuBar'
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcons from './MenuIcons';

const MainMenu = (props) => {
    console.log("MainMenu props=", props);
    const location = useLocation();

    const [open, setOpen] = React.useState(false);
    const [categories, setCategories] = React.useState([]);

    useEffect(() => {
        console.log("props.categoriesAll, mainMenu=", props.categoriesAll);
        setCategories(props.categoriesAll
        )
    }, [props.categoriesAll])

    const handleDrawerOpenClose = (value) => {
        setOpen(value);
    };

    return (
        <div className="main-menu-container">
            <div className="main-menu-content">
                <div className="menu-item">
                    {location.pathname !== '/' ?
                        <NavLink className="text-left" to="/"><FansaLogo size={50} /></NavLink>
                        :
                        <a className="text-left pointer"><FansaLogo size={1000} /></a>
                    }
                </div>

                <div className="menu menu-desktop">
                    <MenuBar menu={categories} closeDrawer={handleDrawerOpenClose} />
                </div>

                <div className="menu menu-mobile">
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        onClick={() => handleDrawerOpenClose(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Drawer
                        variant="persistent"
                        anchor="right"
                        open={open}
                    >
                        <div className="header-menu-burger">
                            <IconButton onClick={() => handleDrawerOpenClose(false)}>
                                <CloseIcon style={{ fontSize: 30 }} />
                            </IconButton>
                            <div className="icons">
                                <MenuIcons closeDrawer={handleDrawerOpenClose} />
                            </div>
                        </div>

                        <MenuBar menu={categories} closeDrawer={handleDrawerOpenClose} />
                    </Drawer>
                </div>
                <div className="icons icons-desktop">
                    <MenuIcons closeDrawer={handleDrawerOpenClose} />
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(MainMenu);